import { ROUTES } from 'app-constants'
import { BaseLayout } from 'components'
import {
  Dashboard,
  MyBills,
  Documents,
  TechnicalSupport,
  PasswordRecoveryDocument,
  EmailPasswordReset,
  UraEvaluation,
  PasswordReset,
  PasswordValidateToken,
  FastBillet,
  FirstAccessDocument,
  FirstAccessValidateToken,
  FirstAccessPassword,
  PasswordResetRequired,
  AppMobileRedirect,
} from 'pages'

export const RESET_PASSWORD_PAGE_PATH = '/redefinir-senha'

export const routes = [
  {
    path: '/',
    privateRoute: true,
    exact: true,
    component: Dashboard,
    layout: BaseLayout,
  },
  {
    path: '/suporte-tecnico',
    privateRoute: true,
    exact: true,
    component: TechnicalSupport,
    layout: BaseLayout,
  },
  {
    path: '/minhas-faturas',
    privateRoute: true,
    exact: true,
    component: MyBills,
    layout: BaseLayout,
  },
  {
    path: '/documentos',
    privateRoute: true,
    exact: true,
    component: Documents,
    layout: BaseLayout,
  },
  {
    path: ROUTES.PASSWORD_RECOVERY.PATH,
    privateRoute: false,
    exact: true,
    component: EmailPasswordReset,
  },
  {
    path: ROUTES.FORGOT_PASSWORD.PATH,
    privateRoute: false,
    exact: true,
    component: PasswordRecoveryDocument,
  },
  {
    path: '/ura-evaluation/:protocolo',
    privateRoute: false,
    exact: true,
    component: UraEvaluation,
  },
  {
    path: RESET_PASSWORD_PAGE_PATH,
    privateRoute: true,
    exact: true,
    ignoreSelectContract: true,
    component: PasswordReset,
  },
  {
    path: ROUTES.VALIDATE_TOKEN.PATH,
    privateRoute: false,
    exact: true,
    component: PasswordValidateToken,
  },
  {
    path: '/boleto-rapido',
    privateRoute: false,
    exact: true,
    component: FastBillet,
    ignoreKeycloak: true,
  },
  {
    path: ROUTES.FIRST_ACCESS.PATH,
    privateRoute: false,
    exact: true,
    component: FirstAccessDocument,
  },
  {
    path: ROUTES.REQUIRED_PASSWORD_UPDATE.PATH,
    privateRoute: true,
    exact: true,
    ignoreSelectContract: true,
    component: PasswordResetRequired,
  },
  {
    path: ROUTES.FIRST_ACCESS_TOKEN.PATH,
    privateRoute: false,
    exact: true,
    component: FirstAccessValidateToken,
  },
  {
    path: ROUTES.FIRST_ACCESS_PASSWORD.PATH,
    privateRoute: false,
    exact: true,
    component: FirstAccessPassword,
  },
  {
    path: ROUTES.APP.PATH,
    privateRoute: false,
    exact: false,
    component: AppMobileRedirect,
  },
]
